$('.pour-vid video').each(function () {
  let newThumbnail = $(this).attr('poster');
  if (newThumbnail && newThumbnail.includes('_small')) {
    newThumbnail = newThumbnail.replace('_small', '');
    $(this).attr('poster', newThumbnail);
  }

  $(this).on('mouseenter', function () {
    this.currentTime = 0;
    this.play();
  });

  // $(this).on('ended', function () {
  //   this.currentTime = 1.6;
  //   this.play();
  // });

  $(this).on('mouseleave', function () {
    this.currentTime = 0;
    this.pause();
  });
});
